export const DEFAULT_BILLING_CURRENCY = 'USD';
export const STRIPE_PLAN_ID = 'planId';
export const STRIPE_PLAN_ID_MINIMUM_SUFFIX = '_minimum';
export const STRIPE_PLAN_ID_USAGE_SUFFIX = '_usage';
export const STRIPE_PLAN_ID_OVERAGES_SUFFIX = '_overages';
export const STRIPE_ORG_ID = 'orgId';
export const GUIDED_IMPLEMENTATION_LOOKUP_KEY = 'spend_implementation';
export const REQUIRES_MICRODEPOSIT_PAYMENT_METHOD_KEY = 'microdeposit_payment_method';
export const ERP_GATEWAY_INTEGRATION_PRICE_LOOKUP_KEY = 'erp_gateway_integration_price';
export const ERP_GATEWAY_INTEGRATION_COUPON_LOOKUP_KEY = 'erp_gateway_integration_coupon';
export const PER_USER_BASIC_PRICE_LOOKUP_KEY = 'per_user_basic_price';
export const PER_USER_PRO_PRICE_LOOKUP_KEY = 'per_user_pro_price';

/**
 * Fallback amount in minor units (cents) for the guided implementation fee,
 * used when the live price cannot be fetched from Stripe.
 * Format using AbacusCurrency with DEFAULT_BILLING_CURRENCY where a display string is needed.
 */
export const GUIDED_IMPLEMENTATION_FALLBACK_PRICE_IN_CENTS = 150000;

export const getGuidedImplementationLookupKey = (currencyCode: string) => {
  if (!currencyCode || currencyCode === DEFAULT_BILLING_CURRENCY) {
    return GUIDED_IMPLEMENTATION_LOOKUP_KEY;
  }

  return `${GUIDED_IMPLEMENTATION_LOOKUP_KEY}_${currencyCode.toLowerCase()}`;
};

export const getErpGatewayPriceLookupKey = (currencyCode: string) => {
  if (!currencyCode || currencyCode === DEFAULT_BILLING_CURRENCY) {
    return ERP_GATEWAY_INTEGRATION_PRICE_LOOKUP_KEY;
  }

  return `${ERP_GATEWAY_INTEGRATION_PRICE_LOOKUP_KEY}_${currencyCode.toLowerCase()}`;
};

export const isErpGatewayPriceLookupKey = (lookupKey: string) => {
  return lookupKey.startsWith(ERP_GATEWAY_INTEGRATION_PRICE_LOOKUP_KEY);
};
